import { MakeCall } from './createMakeCall';

/** @swagger /#api-Default-userUserIdPayoutMethodPayoutMethodIdDelete */
export default (makeCall: MakeCall) => (methodId: number) =>
  makeCall('DELETE', `/api/v2/user/me/payout-method/${methodId}`);
